


























import { Component, Vue } from "vue-property-decorator";
import CityService from "../services/city.service";

@Component({
  components: {},
})
export default class News extends Vue {
  private service = new CityService();

  private news: any = [];

  created() {
    this.service.getLatestNews().then((res) => {
      this.news = res.data;
    });
  }

  view(id) {
    this.$router.push("news/" + id);
  }
}
